import { ApiProperty } from "@nestjs/swagger";
import { VehicleIssueStatusenum } from "@project-management-system/shared-models";

export class VehicleIssueDto {
  @ApiProperty()
  id: number;
  @ApiProperty()
  vehicleId: number;
  @ApiProperty()
  employeeId: number;
  @ApiProperty()
  title: string;
  @ApiProperty()
  description: string;
  @ApiProperty()
  fileUpload: string;
  @ApiProperty()
  priority: string;
  @ApiProperty()
  dueDate: Date;
  @ApiProperty()
  createdAt?: Date;
  @ApiProperty()
  createdUser?: string | null;
  @ApiProperty()
  updatedAt?: Date;
  @ApiProperty()
  updatedUser?: string | null;
  @ApiProperty()
  versionFlag?: number;
  @ApiProperty()
  vehicleStatus: VehicleIssueStatusenum;
}
